import React, {memo, Fragment} from "react";
import PropTypes from "prop-types";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import {FaChevronCircleRight} from "react-icons/fa";
import {Link, useLocation} from "react-router-dom";
import {useDisclosure} from "../../hooks/useDisclosure";
import CreateSite from "../Modal/CreateSite";
import ProtectedContent, {usePermissionCheck} from "../protectedContent";
import SitesList from "./SitesList";

const DropdownLink = (props) => {
  const {
    name,
    icon: Icon,
    dropdownOptions = [],
    activeRouteOptions = [],
    closeCollapse = () => {},
  } = props;
  const {isOpen: isModalOpen, onOpen: openModal, onClose: closeModal} = useDisclosure();
  const {isOpen: showSubItems, onOpen: openSubItems} = useDisclosure();
  const location = useLocation();
  const path = location.pathname.split("/")[2];
  const canViewSite = usePermissionCheck(["view_site"]);

  const handleDropdownItemClick = (item) => {
    if (item.key === "createSites") {
      openModal();
    } else if (item.key === "viewSites") {
      openSubItems();
    }
  };

  return (
    <Fragment>
      {isModalOpen && <CreateSite open={isModalOpen} onClose={closeModal} type="site" />}
      <UncontrolledDropdown nav style={{width: "100%"}}>
        <DropdownToggle
          nav
          className={`sidebar-option roboto-normal ${
            activeRouteOptions.includes(path) ? "active-sidebar" : ""
          }`}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingRight: "15px",
          }}
          data-cy={`cy_${name}`}
        >
          <div>
            <span className="sidebar-icon-container">
              <Icon
                className="sidebar-icon"
                style={{marginRight: "15px", fontSize: "20px"}}
              />
            </span>
            <span>{name}</span>
          </div>
          <FaChevronCircleRight className="dropdown--icon sidebar-icon" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-arrow sidebar-dropdown" right>
          {dropdownOptions.map((option, index) => {
            return option.link ? (
              <DropdownItem
                to={`${option.layout}${option.link}`}
                state={{
                  key: option.key,
                }}
                tag={Link}
                onClick={closeCollapse}
                data-cy={`${option.name}`}
                // eslint-disable-next-line react-hooks/purity
                key={index + option.name + Math.random()}
              >
                <span className="roboto-normal">{option.name}</span>
              </DropdownItem>
            ) : (
              <ProtectedContent
                perms={option.perms || []}
                // eslint-disable-next-line react-hooks/purity
                key={index + option.name + Math.random()}
              >
                <DropdownItem
                  onClick={() => handleDropdownItemClick(option)}
                  data-cy={`${option.name}`}
                >
                  <span className="roboto-normal">{option.name}</span>
                </DropdownItem>
              </ProtectedContent>
            );
          })}
        </DropdownMenu>
      </UncontrolledDropdown>
      {showSubItems && name === "Sites" && (
        <Fragment>
          {canViewSite ? (
            <SitesList closeCollapse={closeCollapse} />
          ) : (
            <div
              style={{
                fontSize: "13px",
                padding: "15px",
              }}
              className="d-flex justify-content-center roboto-normal"
            >
              You do not have permission to view sites
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

DropdownLink.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  dropdownOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      link: PropTypes.string,
      layout: PropTypes.string,
      key: PropTypes.string,
      perms: PropTypes.array,
    })
  ),
  activeRouteOptions: PropTypes.array,
  closeCollapse: PropTypes.func,
};

export default memo(DropdownLink);
